import { KYMW1406Model } from '../kymw1406.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export interface GetCrossMultiResponse {
  CrossMultiInfo: {
    OrderCode: string;
    MediumType: string;
    CrossInfo: {
      CrossCode: string;
      GoodsExplanation: string;
      CatchCopy: string;
    } | '';
    MultiInfo: {
      MultiCode: string;
      GoodsExplanation: string;
      CatchCopy: string;
    } | '';
  };
}

/**
 * クロス設定・マルチ設定情報を取得する。
 *
 * @export
 * @class GetCrossMultiService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCrossMultiService extends PlessJsonResponderSub<GetCrossMultiResponse> {

  private model: KYMW1406Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCrossMultiService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CrossMulti: {
          parameter: {
            OrderCode: this.model.kymw1406Component.inputVO.orderCode,
            MediumType: this.model.kymw1406Component.inputVO.mediumType,
          },
          combination: this.model.goodsInfoList.map((goodsInfo, index) => ({
            parameter: {
              PCode: goodsInfo.PCode,
              Priority: (index + 1).toString()
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1406Model} model
   * @param {RequestGetGoodsInfoListModel} vo
   * @memberof GetCrossMultiService
   */
  execute(model: KYMW1406Model, successFunc?: () => void) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getCrossMulti', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCrossMultiService
   */
  success(data: GetCrossMultiResponse) {
    this.model.updateCrossMulti(data);

    if (this.successFunc) {
      this.successFunc();
    }
  }
}
